<template>
  <div class="col-12-">
    <div class="search-padd">
      <table class="table table-sm table-borderless shadow">
        <thead>
          <tr class="">
            <th>Certification Name</th>
            <th>Certificate Organization</th>
            <th class="text-center">Registration link</th>
            <th class="text-center">Date Created</th>
          </tr>
        </thead>
        <tbody>
          <tr v-show="loading">
            <td colspan="6">
              <div class="loading_show"><div class="spinner-border text-danger"></div></div>
            </td>
          </tr>          
          <tr v-for="(cert, index) in certification_lists">
            <td>{{ cert.text }}</td>
            <td>{{ cert.orgName }}</td>
            <td class="text-center" v-if="cert.link" @click="downloadFunc(cert.link)" style="cursor: pointer;"><img :src="cert.image" width="50px" height="50px" /></td>
            <td class="text-center" v-else><img :src="cert.image" width="50px" height="50px" /></td>
            <td class="text-center">{{ getDate(cert.created_at) }}</td>
          </tr>
          <tr v-if="certification_lists.length == 0">
            <td colspan="6" class="text-center">No certifications found</td>
          </tr>          
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  props: ['accountId'],
  data() {
    return {
      loading: false,
      certification_lists: [],
      status_options: [
        { value: '', text: 'Status' },
        { value: 'DRAFT', text: 'Draft' },
        { value: 'PUBLISH', text: 'Published' },
        { value: 'DEACTIVATED', text: 'Deactivated' }
      ],
    }
  },
  methods: {
    downloadFunc: function(url) {
      window.open(url, '_blank');
      return false;    
    },
    fetchCertificationLists() {
      this.loading = true;
      const params = {
        account_id: this.accountId,
      };
      axios.get('/pathway/certification-lists', {
          params: params
      })
      .then((resp) => {
          this.loading = false;
          this.certification_lists = resp.data;
      })
      .catch(error => {});
    },
    getStatus: function(status) {
      var status_val = this.status_options.findIndex(item => item.value === status);
      return this.status_options[status_val].text;
    },
    getDate(value) {
      return moment(String(value)).utc().format('MM/DD/YYYY')
    },
  },
  created() {
    this.fetchCertificationLists();
  },
}

</script>

<style scoped>
table thead tr {
  background-color: #00ACEE;
  color: #FFFFFF;
}

table tbody button {
  background-color: white;
  color: black;
  border: 1px solid black;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/account_lookup_pathway_certification_lists.vue